import { Inject, Injectable, InjectionToken, Provider } from '@angular/core';
import { ListStateService } from '@modules/common/components/list/list-state.service';
import { SortBy } from '@modules/common/types/SortBy';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';
import { StateService } from '@modules/settings/services/state.service';
import { StateKey } from '@modules/settings/types/state-key';
import { type Message } from '../types/message';
import { MessagesListSortField, MessagesListState } from '../types/messages-list-state';

export interface MessageListStateServiceConfig {
  stateKey?: StateKey;
  withAdvancedSearch?: boolean;
  defaultSort?: SortBy<MessagesListSortField>;
}

export const MessageListStateServiceConfigToken = new InjectionToken<MessageListStateServiceConfig>(
  'Configuration object for message list state service',
);

@Injectable()
export class MessageListStateService extends ListStateService<Message, MessagesListSortField, MessagesListState> {
  declare public readonly state: MessagesListState;

  constructor(
    stateService: StateService,
    advancedSearchService: AdvancedSearchService,
    @Inject(MessageListStateServiceConfigToken) config: MessageListStateServiceConfig,
  ) {
    super();

    this.state = new MessagesListState({
      searchService: advancedSearchService,
      stateService: stateService,
      stateKey: config.stateKey,
      withAdvanced: config.withAdvancedSearch,
      defaultSort: config.defaultSort,
    });
    this.followWorkspace();
  }

  public static providers(config: MessageListStateServiceConfig = {}): Provider[] {
    return super.prepareProviders(MessageListStateServiceConfigToken, config);
  }
}

declare module '@modules/settings/types/state' {
  export interface State {
    [StateKey.messagesListState]?: MessagesListState;
    [StateKey.messagesDPListState]?: MessagesListState;
    [StateKey.messagesFFListState]?: MessagesListState;
  }
}
